// 处理方法
export function generateRouter(routerInfo) {
  let routes = [];
  Object.values(routerInfo).forEach(routeVal => {
    if (routeVal.parent) {
      // 处理 children
      const {hasFound, resultRoutes} = setRouteChildren(routes, routeVal);
      hasFound && (routes = resultRoutes)
    } else { // 无父节点
      routes.push({
        path: routeVal.path,
        name: routeVal.name,
        meta: {title: routeVal.title, backRt: routeVal.backRt, mtBack: routeVal.mtBack, keepAlive: routeVal.keepAlive},
        component: routeVal.component,
        children: [],
      })
    }
  });
  // console.log(routes);
  return routes
}

// 递归处理 children
function setRouteChildren(childrenRoutes = [], curRoute) {
  const hasFound = childrenRoutes.some(curParent => {
    if (curParent.name === curRoute.parent) {
      curParent.children = (curParent.children || []).concat([{
        path: curRoute.path,
        name: curRoute.name,
        meta: {title: curRoute.title, backRt: curRoute.backRt, mtBack: curRoute.mtBack, keepAlive: curRoute.keepAlive},
        component: curRoute.component,
      }]);
      return true
    } else if (curParent.hasOwnProperty('children')) {
      const {hasFound, resultRoutes} = setRouteChildren(curParent.children, curRoute);
      if (hasFound) {
        curParent.children = resultRoutes;
        return true
      }
    }
  });
  return {
    hasFound: hasFound,
    resultRoutes: childrenRoutes,
  }
}
